module.exports = __webpack_public_path__ + "img/18.49a45363.png";